// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".shelf-container[data-v-2548d79f]{padding:1rem}.pad-bottom[data-v-2548d79f]{padding-bottom:1rem}.header-bar[data-v-2548d79f]{display:flex}.header-bar>*[data-v-2548d79f]{margin:0 .125rem}.input[data-v-2548d79f]{flex-basis:25vw}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
